import { render, staticRenderFns } from "./index.vue?vue&type=template&id=65326bda&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65326bda')) {
      api.createRecord('65326bda', component.options)
    } else {
      api.reload('65326bda', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=65326bda&", function () {
      api.rerender('65326bda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/currency/index.vue"
export default component.exports